import { EMPTY_VALUE_DASH } from '@/constants/common';
import { Diamond } from '@/entities/Diamond';
import { reverseString } from '@/utils/reverseString';

export const FIELD_CLARITY = {
  key: 'clarity',
  label: 'Clarity',
  fullLabel: 'Clarity',
  getter: ({ clarity }: Diamond) => {
    const value = clarity?.title;

    return value ? reverseString(value, '-') : EMPTY_VALUE_DASH;
  },
  getterValue: ({ clarity }: Diamond) => clarity?.mc ?? null,
};

export const FIELD_FLUORESCENCE = {
  key: 'fluorescence',
  label: 'Fluorescence',
  fullLabel: 'Fluorescence',
  getter: ({ fluorescence }: Diamond) => fluorescence?.title ?? null,
  getterValue: ({ fluorescence }: Diamond) => fluorescence?.mc ?? null,
};

export const FIELD_SPREAD = {
  key: 'spread',
  label: 'Apparent size',
  fullLabel: 'Apparent size',
  getter: ({ performance }: Diamond) => performance?.spread?.global?.hr ?? EMPTY_VALUE_DASH,
  getterValue: ({ performance }: Diamond) => performance?.spread?.global?.mc ?? null,
};

export const FIELD_OPTICAL_SYMMETRY = {
  key: 'symmetry.val',
  label: 'O. Symmetry',
  fullLabel: 'Optical<br>Symmetry',
  getter: ({ performance }: Diamond) => {
    const value = performance?.symmetry?.global?.hr;

    return value ? reverseString(value, '-') : EMPTY_VALUE_DASH;
  },
  getterValue: ({ performance }: Diamond) => performance?.symmetry?.global?.mc ?? null,
};

export const FIELD_COLOR = {
  key: 'color',
  label: 'Color',
  fullLabel: 'Color',
  getter: ({ color }: Diamond) => {
    const value = color?.title;

    return value ? reverseString(value, '-') : EMPTY_VALUE_DASH;
  },
  getterValue: ({ color }: Diamond) => color?.mc ?? null,
};

export const COMMON_FIELDS = [FIELD_COLOR, FIELD_CLARITY, FIELD_FLUORESCENCE, FIELD_SPREAD, FIELD_OPTICAL_SYMMETRY];
